import React from "react";
import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

export const HeroSection: React.FC = () => {
  return (
    <section className="relative pt-20 sm:pt-24 pb-12 sm:pb-0 overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 max-w-7xl relative z-10">
        <div className="text-center pt-12 sm:pt-16 pb-6 sm:pb-8">
          <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-bold mb-4 sm:mb-6 tracking-tight animate-fade-in-up text-gray-900 dark:text-white">
            Transforme seus
            <br />
            <span className="bg-gradient-to-r from-purple-400 via-pink-500 to-purple-600 bg-clip-text text-transparent animate-gradient">
              treinos
            </span>
          </h1>

          <p
            className="text-lg sm:text-xl md:text-2xl text-gray-600 dark:text-gray-400 mb-8 sm:mb-10 max-w-2xl mx-auto font-light px-4 animate-fade-in-up"
            style={{ animationDelay: "200ms" }}
          >
            Tecnologia, acompanhamento e inteligência artificial em uma
            plataforma completa
          </p>

          <div
            className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center mb-6 sm:mb-8 px-4 animate-fade-in-up"
            style={{ animationDelay: "400ms" }}
          >
            <Link
              to="/cadastrar"
              className="group px-6 sm:px-8 py-3 sm:py-4 bg-gradient-to-r from-purple-600 to-purple-700 text-white font-semibold rounded-full hover:from-purple-500 hover:to-purple-600 transition-all duration-300 inline-flex items-center gap-2 justify-center transform hover:scale-105 hover:shadow-2xl shadow-purple-500/50"
            >
              Começar agora
              <ChevronRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Link>
            <a
              href="/login"
              className="px-6 sm:px-8 py-3 sm:py-4 bg-white/10 dark:bg-white/5 backdrop-blur-sm border-2 border-gray-300 dark:border-gray-700 text-gray-900 dark:text-white font-semibold rounded-full hover:bg-white/20 dark:hover:bg-white/10 hover:border-purple-400 dark:hover:border-purple-500 transition-all duration-300 inline-flex items-center justify-center transform hover:scale-105"
            >
              Já tenho conta
            </a>
          </div>

          {/* App Store Buttons */}
          <div
            className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center mb-12 sm:mb-20 px-4 animate-fade-in-up"
            style={{ animationDelay: "600ms" }}
          >
            <a
              href="https://apps.apple.com/br/app/easyfit/id1473322908"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 px-5 sm:px-6 py-3 bg-black dark:bg-white text-white dark:text-black rounded-2xl hover:opacity-80 transition-all duration-300 transform hover:scale-105 hover:shadow-xl w-full sm:w-auto max-w-xs"
            >
              <svg
                className="w-7 sm:w-8 h-7 sm:h-8 flex-shrink-0"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M18.71 19.5C17.88 20.74 17 21.95 15.66 21.97C14.32 22 13.89 21.18 12.37 21.18C10.84 21.18 10.37 21.95 9.09997 22C7.78997 22.05 6.79997 20.68 5.95997 19.47C4.24997 17 2.93997 12.45 4.69997 9.39C5.56997 7.87 7.12997 6.91 8.81997 6.88C10.1 6.86 11.32 7.75 12.11 7.75C12.89 7.75 14.37 6.68 15.92 6.84C16.57 6.87 18.39 7.1 19.56 8.82C19.47 8.88 17.39 10.1 17.41 12.63C17.44 15.65 20.06 16.66 20.09 16.67C20.06 16.74 19.67 18.11 18.71 19.5ZM13 3.5C13.73 2.67 14.94 2.04 15.94 2C16.07 3.17 15.6 4.35 14.9 5.19C14.21 6.04 13.07 6.7 11.95 6.61C11.8 5.46 12.36 4.26 13 3.5Z" />
              </svg>
              <div className="text-left">
                <div className="text-xs">Baixar na</div>
                <div className="text-base sm:text-lg font-semibold -mt-1">
                  App Store
                </div>
              </div>
            </a>

            <a
              href="https://play.google.com/store/apps/details?id=br.com.easyfit.app"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 px-5 sm:px-6 py-3 bg-black dark:bg-white text-white dark:text-black rounded-2xl hover:opacity-80 transition-all duration-300 transform hover:scale-105 hover:shadow-xl w-full sm:w-auto max-w-xs"
            >
              <svg
                className="w-7 sm:w-8 h-7 sm:h-8 flex-shrink-0"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.5,12.92 20.16,13.19L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" />
              </svg>
              <div className="text-left">
                <div className="text-xs">Disponível no</div>
                <div className="text-base sm:text-lg font-semibold -mt-1">
                  Google Play
                </div>
              </div>
            </a>
          </div>
        </div>

        {/* Hero Image */}
        <div
          className="relative w-full max-w-6xl mx-auto px-4 animate-fade-in-up"
          style={{ animationDelay: "800ms" }}
        >
          <div className="relative rounded-2xl sm:rounded-3xl overflow-hidden shadow-2xl transform hover:scale-[1.02] transition-transform duration-500">
            <img
              src="https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=1600&h=900&fit=crop"
              alt="Fitness Training"
              className="w-full h-auto"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-white/60 dark:from-black/60 to-transparent"></div>
          </div>
        </div>
      </div>
    </section>
  );
};
